import { Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CuentasEnvioRecibos, FCuentasEnvioMasivoRecibos, FCuentasEnvioMasivoRecibosInput } from "../entidades/entidades";
import Utils from "../shared/utilerias/utils";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FCuentasEnvioMasivoRecibosService {
  private actionUrl: string;
  private actionUrlBusquedas: string;
  private actionUrlEvioCorreo: string;  
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    //this.actionUrl = Utils.getBaseUrlApiWeb() + "/FCuentasEnvioMasivoRecibos/";
    this.actionUrlBusquedas = Utils.getBaseUrlApiWeb() + "/FCuentasEnvioMasivoRecibos/";
    this.actionUrlEvioCorreo = Utils.getBaseUrlApiWeb() + "/EnviarCorreo/EnvioResivoEstadoCuenta";
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Accept", "application/json");
  }

  getBusquedas(fCuentasEnvioMasivoRecibosInput: FCuentasEnvioMasivoRecibosInput): Observable<FCuentasEnvioMasivoRecibos[]> {
    return this.http
      .post<FCuentasEnvioMasivoRecibos[]>(this.actionUrlBusquedas, fCuentasEnvioMasivoRecibosInput, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }

  envioCorreoResibosMasivo(cuentasEnvioRecibos: CuentasEnvioRecibos[]): Observable<CuentasEnvioRecibos[]> {
    return this.http
      .post<CuentasEnvioRecibos[]>(this.actionUrlEvioCorreo, cuentasEnvioRecibos, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("Se produjo un error:", error.error.message);
    } else {
      console.error(
        `Código devuelto por el backend ${error.status}, ` + `el cuerpo estaba: ${error.error}`
      );
    }
    return throwError("Algo malo pasó; por favor inténtalo de nuevo más tarde.");
  }
}
